import { DataTableColumnHeader } from "@/components/data-table/data-table-column-header";
import { translateUserHistoryAction } from "@/translation/user-history.translation";
import { AdminUserHistoryDTO } from "@shaarp/common";
import { ColumnDef } from "@tanstack/react-table";
import DataTableCellAdminUsersHistoryTarget from "./data-table-cell-admin-users-history-target";
import DataTableCellAdminUsersHistoryTeamAvatar from "./data-table-cell-admin-users-history-team-avatar";
import DataTableCellAdminUsersHistoryUserAvatar from "./data-table-cell-admin-users-history-user-avatar";
import { useTranslation } from "@/hooks/useTranslation";

export const dataTableAdminUsersHistoryColumns = () => {
  const { t } = useTranslation();

  return [
    {
      id: "Date",
      accessorKey: "date",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminUsersHistory.columns.date")}
        />
      ),
      cell: ({ cell }) => {
        const userHistory = cell.row.original as AdminUserHistoryDTO;
        return new Date(userHistory.date).toLocaleString();
      },
    },
    {
      id: "Équipe",
      accessorKey: "userId",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminUsersHistory.columns.team")}
        />
      ),
      cell: ({ cell }) => {
        const userHistory = cell.row.original as AdminUserHistoryDTO;
        return (
          <DataTableCellAdminUsersHistoryTeamAvatar userHistory={userHistory} />
        );
      },
    },
    {
      id: "Utilisateur",
      accessorKey: "userId",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminUsersHistory.columns.user")}
        />
      ),
      cell: ({ cell }) => {
        const userHistory = cell.row.original as AdminUserHistoryDTO;
        return (
          <DataTableCellAdminUsersHistoryUserAvatar userHistory={userHistory} />
        );
      },
    },
    {
      id: "Action",
      accessorKey: "action",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminUsersHistory.columns.action")}
        />
      ),
      cell: ({ cell }) => {
        const userHistory = cell.row.original as AdminUserHistoryDTO;
        return translateUserHistoryAction(userHistory.action, t);
      },
    },
    {
      id: "Cible",
      accessorKey: "target",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("admin.dataTableAdminUsersHistory.columns.target")}
        />
      ),
      cell: ({ cell }) => {
        const userHistory = cell.row.original as AdminUserHistoryDTO;
        return (
          <DataTableCellAdminUsersHistoryTarget userHistory={userHistory} />
        );
      },
    },
  ] as ColumnDef<AdminUserHistoryDTO>[];
};
